<div
    id="{{ element.id }}"
    [attr.data-e2e]="'activity-' + element.id"
>
    <surveys-element-html [element]="htmlElement"></surveys-element-html>
</div>
